import { v4 as uuidv4 } from 'uuid';

interface DeviceInfo {
	clientId: string;
	deviceName: string;
	deviceType: string;
	browser: string;
	os: string;
	timestamp: number;
}

const DEVICE_INFO_KEY = 'guest_device_info';
const EXPIRY_DAYS = 30;

// Get browser name and version
const getBrowserInfo = (): string => {
	const ua = navigator.userAgent;
	let browser = 'Unknown';

	if (ua.includes('Chrome')) browser = 'Chrome';
	else if (ua.includes('Firefox')) browser = 'Firefox';
	else if (ua.includes('Safari')) browser = 'Safari';
	else if (ua.includes('Edge')) browser = 'Edge';
	else if (ua.includes('Opera')) browser = 'Opera';

	return browser;
};

// Get OS information
const getOSInfo = (): string => {
	const ua = navigator.userAgent;
	let os = 'Unknown';

	if (ua.includes('Windows')) os = 'Windows';
	else if (ua.includes('Mac')) os = 'MacOS';
	else if (ua.includes('Linux')) os = 'Linux';
	else if (ua.includes('Android')) os = 'Android';
	else if (ua.includes('iOS')) os = 'iOS';

	return os;
};

// Get device type
const getDeviceType = (): string => {
	const ua = navigator.userAgent;
	if (/Mobi|Android|iPhone|iPad|iPod/i.test(ua)) {
		return 'Mobile';
	}
	return 'Desktop';
};

// Generate a readable device name
const generateDeviceName = (): string => {
	const os = getOSInfo();
	const browser = getBrowserInfo();
	const type = getDeviceType();
	const timestamp = new Date().toLocaleDateString();
	return `${type}-${os}-${browser}-${timestamp}`;
};

export const getOrCreateDeviceInfo = (): DeviceInfo => {
	try {
		const storedInfo = localStorage.getItem(DEVICE_INFO_KEY);

		if (storedInfo) {
			const deviceInfo: DeviceInfo = JSON.parse(storedInfo);
			const isExpired =
				Date.now() - deviceInfo.timestamp > EXPIRY_DAYS * 24 * 60 * 60 * 1000;

			if (!isExpired) {
				return deviceInfo;
			}
		}

		// Create new device info if none exists or expired
		const newDeviceInfo: DeviceInfo = {
			clientId: uuidv4(),
			deviceName: generateDeviceName(),
			deviceType: getDeviceType(),
			browser: getBrowserInfo(),
			os: getOSInfo(),
			timestamp: Date.now(),
		};

		localStorage.setItem(DEVICE_INFO_KEY, JSON.stringify(newDeviceInfo));
		return newDeviceInfo;
	} catch (_error) {
		// Fallback with basic info if localStorage fails
		return {
			clientId: uuidv4(),
			deviceName: 'Unknown Device',
			deviceType: 'Unknown',
			browser: 'Unknown',
			os: 'Unknown',
			timestamp: Date.now(),
		};
	}
};
